// extracted by mini-css-extract-plugin
export var bar = "BlogFooter__bar-mmfrR";
export var button = "BlogFooter__button-d20FZ";
export var copyright = "BlogFooter__copyright-v4h0X";
export var nav = "BlogFooter__nav-PBv1E";
export var wrapper = "BlogFooter__wrapper-Nv93m";